import moment from 'moment';
moment.locale('th');
moment().utcOffset(-7);
export default moment;



// WEBPACK FOOTER //
// ./resources/assets/js/_moment.js